/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '@store/mutations.constants';
import licenseState from './state';

export const state = licenseState;
const mutations = {
  [storeMutations.designationMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.designation = res.data.data;
    }
  },
  [storeMutations.setDesignationMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.designations = res.data;
    }
  },
};
export default {...mutations };